import { createContext, useContext } from 'react';

export type ColorSlot = 'frame' | 'upholstery' | 'stitches' | 'arm';

/** Do backend (ProductColor::hexMapsForPoFields): chave normalizada, inclui o de-para. */
export type ColorHexMaps = Record<ColorSlot, Record<string, string>>;

/** Mesma normalização de ProductColorAlias::normalizeAlias (minúsculas, espaços colapsados). */
const normalizeColorName = (name: string) => name.trim().replace(/\s+/g, ' ').toLowerCase();

export function resolveColorHex(
    slot: ColorSlot,
    name: string | null | undefined,
    maps?: Partial<ColorHexMaps> | null,
): string | null {
    if (!name || !name.trim()) return null;
    const hex = maps?.[slot]?.[normalizeColorName(name)];
    if (!hex) return null;
    return hex.startsWith('#') ? hex : `#${hex}`;
}

export const ColorHexMapsContext = createContext<Partial<ColorHexMaps> | null>(null);

export const useColorHexMaps = () => useContext(ColorHexMapsContext);
